import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HeaderTitleInterface } from '../types/header.interface';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private titleSubject = new BehaviorSubject<HeaderTitleInterface>({
    title: '',
    address: '',
  });
  constructor() {}

  setHeader(titleObject: HeaderTitleInterface) {
    this.titleSubject.next(titleObject);
  }

  getHeader() {
    return this.titleSubject.asObservable();
  }
}
